export default __webpack_public_path__ + "static/media/DSC_0532.eeb40e56.webp";